// eslint-disable-next-line
import * as actions from "constants/cartConstants";

interface IActions {
  type: string;
  payload?: string;
}

export const cartReducer = (state = { cartItem: [] }, action: IActions) => {
  switch (action.type) {
    case actions.CART_REQUEST:
      return { loading: true };
    case actions.CART_ADD_REQUEST:
      return { loading: true };
    case actions.CART_UPDATE_REQUEST:
      return { loading: true };
    case actions.CART_DELETE_REQUEST:
      return { loading: true };
    case actions.CART_REQUEST_SUCCESS:
      return { loading: false, cartItem: action.payload };
    case actions.CART_ADD_SUCCESS:
      return { loading: false, cartItem: action.payload };
    case actions.CART_UPDATE_SUCCESS:
      return { loading: false, cartItem: action.payload };
    case actions.CART_DELETE_SUCCESS:
      return { loading: false, cartItem: action.payload };
    case actions.CART_REQUEST_ERROR:
      return { loading: false, error: action.payload };
    case actions.CART_ADD_ERROR:
      return { loading: false, error: action.payload };
    case actions.CART_UPDATE_ERROR:
      return { loading: false, error: action.payload };
    case actions.CART_DELETE_ERROR:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
